import React from 'react'
import { ApexCharts } from '../../../../Components'
import { LogAcessoGetEvolucaoPosts } from '../../../../Service/ApiService'
import ChartCard from '../ChartCard'
import { CORES, larguraColuna, eixoContagem, eixoDias, formatarNumero, tooltipDias, useIndicador } from '../helpers'

export default function EvolucaoPosts({ filters }) {
  const { status, data } = useIndicador(LogAcessoGetEvolucaoPosts, filters, (d) => !d.labels?.length)
  const dias = data?.labels || []

  const options = {
    chart: { type: 'line', stacked: false },
    colors: [CORES.azul, CORES.rosa, CORES.verde],
    stroke: { width: [0, 0, 3], curve: 'smooth' },
    markers: { size: [0, 0, 4] },
    plotOptions: { bar: { columnWidth: larguraColuna(dias.length), borderRadius: 2 } },
    xaxis: eixoDias(dias),
    yaxis: [
      eixoContagem([...(data?.views || []), ...(data?.likes || [])], { seriesName: 'Views', title: { text: 'Views e likes' } }),
      { seriesName: 'Views', show: false },
      eixoContagem(data?.posts || [], { seriesName: 'Posts', opposite: true, title: { text: 'Posts' } }),
    ],
    legend: { position: 'top', horizontalAlign: 'right' },
    tooltip: { ...tooltipDias, shared: true, intersect: false, y: { formatter: formatarNumero } },
  }

  const series = [
    { name: 'Views', type: 'column', data: data?.views || [] },
    { name: 'Likes', type: 'column', data: data?.likes || [] },
    { name: 'Posts', type: 'line', data: data?.posts || [] },
  ]

  return (
    <ChartCard title="Engajamento dos posts" subtitle="Views, likes e posts publicados por dia" status={status}>
      <ApexCharts options={options} series={series} type="line" height={280} />
    </ChartCard>
  )
}
